import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/user/userSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import goalsReducer from './slices/goals/goalsSlice';
import commentsReducer from './slices/comments/commentsSlice';
import contextMenuReducer from './slices/contextMenu/contextMenuSlice';
import foldersSlice from './slices/resources/folders/foldersSlice';
import docsSlice from './slices/resources/docs/docsSlice';
import vaultsSlice from './slices/vaults/vaultsSlice';
import remindersSlice from './slices/reminders/remindersSlice';
import journalsSlice from './slices/journals/journalsSlice';
import journalTemplatesSlice from './slices/journalTemplates/journalTemplatesSlice';
import fourBoxesTemplatesSlice from './slices/fourBoxesTemplates/fourBoxesTemplatesSlice';
import employeesSlice from './slices/employees/employeesSlice';
import organisationsSlice from './slices/organisations/organisationsSlice';
import coachesSlice from './slices/coaches/coachesSlice';
import userAccessSlice from './slices/userAccess/userAccessSlice';
import dashboardSlice from './slices/dashboard/dashboardSlice';

const rootReducer = combineReducers({
  user: userReducer,
  goals: goalsReducer,
  comments: commentsReducer,
  contextMenu: contextMenuReducer,
  folders: foldersSlice,
  docs: docsSlice,
  vaults: vaultsSlice,
  reminders: remindersSlice,
  journals: journalsSlice,
  journalTemplates: journalTemplatesSlice,
  boxTemplates: fourBoxesTemplatesSlice,
  employees: employeesSlice,
  organisations: organisationsSlice,
  coaches: coachesSlice,
  access: userAccessSlice,
  dashboard: dashboardSlice,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
  // reducer: {
  //   user: userReducer,
  // },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     serializableCheck: false,

  //     // serializableCheck: {
  //     //   // Ignore these action types
  //     //   ignoredActions: ['user/login/fulfilled'],
  //     //   // Ignore these field paths in all actions
  //     //   // ignoredActionPaths: ['user.userInfo.config.adapter'],
  //     //   // Ignore these paths in the state
  //     //   // ignoredPaths: ['items.dates'],
  //     // },
  //   }),
});

export const persistor = persistStore(store);
